import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_wallpaper: FaireCategoryEntity = {
  token: "cat_wallpaper",
  type: "category",
  name: "Wallpaper & transfers",
  level: 3,
  parentToken: "cat_home-decor-wall",
  href: "/category/home-decor/wall-decor/wallpaper-transfers",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
